'use client';

import Image from 'next/image';
import { memo } from 'react';
import { Flexbox } from 'react-layout-kit';

import useSafeErrorTranslations from '@/components/error/use-safe-error-translations';
import { domId } from '@/lib/dom-id';

const NotFound = memo(() => {
  const t = useSafeErrorTranslations();
  return (
    <Flexbox
      align="center"
      data-testid={domId('div', 'not-found-page')}
      gap={16}
      justify="center"
      style={{ minHeight: '100vh', width: '100%' }}
    >
      <Image
        alt=""
        data-testid={domId('img', 'not-found-illustration')}
        height={200}
        priority
        src="/images/errors/page_not_found.svg"
        unoptimized
        width={240}
      />
      <h2
        style={{
          color: '#444746',
          fontSize: 24,
          fontWeight: 600,
          lineHeight: 1.4,
          margin: 0,
          textAlign: 'center',
        }}
      >
        {t('notFound.title')}
      </h2>
      <p
        style={{
          color: '#444746',
          fontFeatureSettings: "'salt'",
          fontSize: 14,
          lineHeight: 1.4,
          margin: 0,
          textAlign: 'center',
        }}
      >
        {t('notFound.desc')}
      </p>
      <a
        data-testid={domId('btn', 'go-home')}
        href="/"
        style={{
          backgroundColor: '#026EEE',
          borderRadius: 8,
          color: '#ffffff',
          display: 'inline-block',
          fontSize: 14,
          fontWeight: 600,
          lineHeight: 1.4,
          marginTop: 8,
          padding: '10px 24px',
          textDecoration: 'none',
        }}
      >
        {t('goToHome')}
      </a>
    </Flexbox>
  );
});

NotFound.displayName = 'NotFound';

export default NotFound;
